import { computed, ref } from "vue";

import VocabService from "@/common/api/vocab.service";
import NotificationService from "@/common/notification.service";
import { type Achievement, AchievementType } from "@/common/types/vocab";
import { i18n } from "@/i18n";

import { useVocabBadges } from "./use-vocab-badges";

export const useVocabAchievementProgress = () => {
  const { t } = i18n.global;

  const achievements = ref<Achievement[]>([]);

  const sortedAchievements = computed<Achievement[]>(() =>
    [...achievements.value]
      .sort((a, b) => {
        // If an achievement is already opened, it
        // won't be as important, hence it's sorted last.
        if (a.badge?.openedAt) {
          return 1;
        }

        if (b.badge?.openedAt) {
          return -1;
        }

        if (b.type === AchievementType.Campaign && a.type !== AchievementType.Campaign) {
          return 1;
        }

        if (a.type === AchievementType.Campaign && b.type !== AchievementType.Campaign) {
          return -1;
        }

        return b.progress / b.steps - a.progress / a.steps;
      })
      .slice(0, 3)
  );

  const {
    badge: redeemBadge,
    isRedemptionModalOpen,
    onRedeemClick,
    onCloseRedemptionModal,
    onBadgeRedeem
  } = useVocabBadges(achievements);

  const loadAchievements = async () => {
    try {
      achievements.value = (await VocabService.getLatestAchievements()).data.data;
    } catch (error) {
      NotificationService.error(t("vocab.quizAchievementProgress.loadingError"));
    }
  };

  return {
    loadAchievements,
    sortedAchievements,

    redeemBadge,
    isRedemptionModalOpen,
    onRedeemClick,
    onCloseRedemptionModal,
    onBadgeRedeem
  };
};
